var map = {
	"./Untitled video - Made with Clipchamp (1).mp4": 9617,
	"./VIDEO-2024-09-12-00-23-45.mp4": 1367,
	"./VIDEO-2024-09-12-00-30-42.mp4": 1924,
	"./VIDEO-2024-09-12-00-47-49 2.mp4": 543,
	"./VIDEO-2024-09-12-00-47-49.mp4": 6445,
	"./WhatsApp Video 2024-03-08 at 16.29.37.mp4": 1905,
	"./WhatsApp Video 2024-03-08 at 16.30.27.mp4": 5516,
	"./WhatsApp Video 2024-03-08 at 16.31.04.mp4": 1114,
	"./WhatsApp Video 2024-03-08 at 16.31.45.mp4": 3755,
	"./phoneBackgroundVideo.mp4": 5523,
	"./phoneBackgroundVideo3.mp4": 204,
	"./phoneBackgroundVideo_short.mp4": 3952,
	"./video1.mp4": 4224,
	"./video2.mp4": 2375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8436;